import { Navigate } from 'react-router-dom'
import Loading from './Loading'
import { useAuthContext } from '../context/AuthContext'

const AuthGuard = ({ children }) => {
  const currentWorkspace = localStorage.getItem('currentWorkspace')

  const { isAuthenticated, isInitialized } = useAuthContext[currentWorkspace]()

  if (!isInitialized) {
    return <Loading style={{ width: '100vw', height: '100vh' }} />
  }

  if (!isAuthenticated) {
    return <Navigate to='/login' />
  }

  return <>{children}</>
}

export default AuthGuard
